import requestAction from '../../utils/requestAction'

export const uploadPreorderRejectFile = (formData: FormData, preoderId: number, handleResponse: (fileId: string) => void) =>
  requestAction('PREORDER_REJECT_UPLOADFILE')(
    `preorders/upload/reject/${preoderId}`,
    'POST',
    formData,
    undefined,
    'file',
    (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse(response.fileId) })

